import { Box } from "@mui/material";
import React, { useCallback, useState } from "react";
import { PieChart, Pie, Sector, Legend, Cell } from "recharts";
import "./index.css";

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value,
  } = props;

  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + outerRadius * cos;
  const sy = cy + outerRadius * sin;
  const mx = cx + (outerRadius + 20) * cos;
  const my = cy + (outerRadius + 20) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 20;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";

  return (
    <g>
      <text
        x={cx}
        y={cy - 5}
        dy={8}
        textAnchor="middle"
        width={20}
        className={"change"}
        fill={"#1E729F"}
      >
        {`${payload.total}`}
      </text>
      <text
        x={cx}
        y={cy + 15}
        dy={8}
        textAnchor="middle"
        className={"change2"}
        fill={"#606060"}
        fontFamily="Nunito"
      >
        {payload.descricao}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 8}
        y={ey}
        textAnchor={textAnchor}
        fill={fill}
      >{`${value} (${(percent * 100).toFixed(0)}%)`}</text>
    </g>
  );
};

export default function GenericPieChart({ data, COLORS, PieChartWidth }) {
  const defaultData = [
    { descricao: "Sem dados", name: "Sem dados", total: 0, value: 0 },
  ];

  return (
    <PieChart width={PieChartWidth} height={260} className="PieChartCustom">
      <Pie
        label={renderActiveShape}
        data={
          data.length === 0 || data[0].total === 0
            ? defaultData
            : data.filter((item) => item.value > 0)
        }
        cx={"50%"}
        cy={"53%"}
        innerRadius={65}
        outerRadius={75}
        fill="#8884d8"
        dataKey="value"
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie>
      <Legend
        layout="horizontal"
        verticalAlign="bottom"
        align="center"
        width="100%"
        wrapperStyle={{ bottom: -8 }}
      />
    </PieChart>
  );
}
